import { createContext, useContext } from 'react'

import { RedirectPath } from './Redirects'

export interface RedirectContextValues {
  redirectPath: RedirectPath
}

export const RedirectContext = createContext<RedirectContextValues | null>(null)

export const useOptionalRedirectPathValue = (): RedirectContextValues | null => {
  return useContext(RedirectContext)
}

export const useRedirectPathValue = (): RedirectContextValues => {
  const context = useContext(RedirectContext)

  if (!context) {
    throw new Error(
      'Calling useRedirectPathValue without an appropriate provider!',
    )
  }

  return context
}
